export const GENERAL_ELECTRIC = 'GENERAL_ELECTRIC';

export const MM_INTEGRATION_TYPES = {
    ROCKET_SHIPPING: 'Rocket Shipping',
    TFORCE: 'TForce',
    METRO: 'Metro',
    CUSTOMCO: 'Custom Global',
};

export const E2E_INTEGRATION_TYPES = {
    tforce_id: 'TForce',
    metro_id: 'Metro',
    customco_id: 'Custom Global',
};
